import React from "react";
import ErrorBoundaryFallback from "./ErrorBoundaryFallback";

/**
 * Class-based error boundary — React still requires this pattern in 2026.
 * Any child render error caught here shows the fallback UI instead of a blank
 * white screen.
 */
export default class ErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
     
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }

  resetError = () => this.setState({ error: null });

  render() {
    if (this.state.error) {
      return <ErrorBoundaryFallback error={this.state.error} resetError={this.resetError} />;
    }
    return this.props.children;
  }
}
